import lodash from "lodash";
import Base from "../base.store";
import moment from "moment";
import { filter } from "../../../../utils/search";
import { cacheTime } from "../../../../utils/constant";

const baseUrl = "/api/v1/master/tambons";
const base = new Base(baseUrl);

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {
        listByAmphur: {},
        cacheDate: {
            listByAmphur: {},
        },
    }),
    getters: {
        ...base.getters,
    },
    actions: {
        ...base.actions,
        cacheFindAll(context, { where, options }) {
            let force = options?.force ? options.force : false;
            const cacheDateResult = context.state.cacheDate.list;
            if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                force = true;
            }
            const sort = [{ name: "seq", type: "ASC" }];
            const list = context.state.list || [];
            if (list.length > 0 && !force) {
                return filter({ list, where, sort });
            }
            return context.dispatch("findAll", { criteria: { select: ["*"] } }).then((list) => filter({ list, where, sort }));
        },
        cacheFindAllByAmphur(context, { where, amphurId, options }) {
            let force = options?.force ? options.force : false;
            const cacheDateResult = context.state.cacheDate.listByAmphur[amphurId];
            if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                force = true;
            }
            const sort = [{ name: "seq", type: "ASC" }];
            const list = context.state.listByAmphur[amphurId] || [];
            if (list.length > 0 && !force) {
                return filter({ list, where, sort });
            }
            return context.dispatch("findAllByAmphur", { amphurId }).then((list) => filter({ list, where, sort }));
        },
        findAllByAmphur(context, { criteria, config, amphurId }) {
            criteria = lodash.merge(
                {
                    select: ["*", "refAmphur.*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "seq", type: "ASC" }],
                    where: [
                        { name: "isActive", type: "Boolean", operator: "=", value: true },
                        { name: "refAmphur.id", type: "UUID", operator: "=", value: amphurId },
                    ],
                },
                criteria
            );
            return context.dispatch("search", { criteria, config }).then((page) => {
                const list = page.data;
                context.commit("setListByAmphurResult", { amphurId, list });
                return list;
            });
        },
    },
    mutations: {
        ...base.mutations,
        setListByAmphurResult(state, { amphurId, list }) {
            state.listByAmphur[amphurId] = list;
            state.cacheDate.listByAmphur[amphurId] = moment().add(cacheTime, "ms");
        },
    },
};
